export enum WhizActionType {
    USER_REPLY = "USER_REPLY",
    NAVIGATION = "NAVIGATION",
    CONFIGURATION = "CONFIGURATION",
}

export interface WhizMessageAction {
    type: WhizActionType;
    title: string;
    data: { [key: string]: any };
}
